import React, { useEffect, useState } from "react";
import img3 from '../../../../Assets/add/img3.png'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useLocation, useNavigate } from "react-router-dom";
import { Circle } from "lucide-react";
import { Filter } from "lucide-react";
import { CheckCircle, XCircle, ArrowDownAZ, ArrowDownZA, ArrowRightCircle, MoveRight, MapPin } from "lucide-react";
import { gsap } from 'gsap';
import TimelinePopup from "../../../../Component/Vendors/TimeLinePopUp";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowLeft } from 'lucide-react';



const HistoryDriverPage = () => {
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoadingStates, setIsLoadingStates] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showOptionsFor, setShowOptionsFor] = useState(null);
    const [showHistoryFor, setShowHistoryFor] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);




    const navigate = useNavigate();
    const location = useLocation()

    const handleSearch = (e) => {
        const val = e.target.value.toLowerCase();
        setSearchTerm(val);
        setFilteredStates(
            states.filter((state) =>
                state.name.toLowerCase().includes(val)
            )
        );
    };


    const toggleFilter = () => {
        setShowFilter((prev) => !prev);
    };

    const handleSelect = () => {
        if (selectedState) {
            alert(`You selected: ${selectedState.name}`);
        }
    };

    useEffect(() => {
        if (location.state?.id) {
            const fetchAllHistory = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriverHistory/${location.state?.id}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });
                    console.log("response", response);

                    if (response.ok) {
                        const data = await response.json();
                        // toast.success('got vehicle data successfully!');
                        console.log('Response from server:', data.data);
                        setData(data.data); // Save the fetched data
                        setFilteredData(data.data); // Initialize filtered data
                        setIsLoading(false);

                    } else {
                        const errorData = await response.json();
                        toast.error(` ${errorData.message || 'Retry Getting History Details !!!'}`);
                        console.error('Error response from server:', errorData);
                        setIsLoading(false);
                    }
                } catch (error) {
                    // error.message("Error fetching:", error);
                    toast.error('Error fetching vehicle data. Please try again later.');
                    console.error('Error fetching vehicle data:', error);
                }
            }
            fetchAllHistory();
        }
    }, [location.state])

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>Loading...</p>
            </div>
        );
    }



    return (
        <div className="min-h-screen h-screen   bg-gradient-to-b from-[#2db6ff] to-[#d97aff]  flex flex-col  font-satoshi">
            {/* Search Input */}
            {/* Top section */}
            <ToastContainer />
            <div className="p-6 text-white text-center">
                 <div onClick={() => navigate(-1)} className='fixed top-6 left-3'>
                                    <ArrowLeft />
                                </div>
                <h1 className="font-bold mb-2 sm:text-sm md:text-xl">History Of Vehicle
                    <span className="text-gray-900"> {location.state?.vehicleNo}</span></h1>
            </div>

            <div className="bg-white rounded-t-3xl -mt-4 flex-1 flex-col items-center">


                <div className="relative">

                    <div className="flex items-center gap-1">
                        <div className="py-4 pr-4 pl-2 flex-1 border-b">
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearch}
                                style={{ border: '1px solid gray' }}
                                className="w-full p-3 rounded-xl border  outline-none"
                            />
                        </div>
                        <button onClick={toggleFilter}>
                            <Filter className="w-6 h-6 text-gray-600 pr-2" />
                        </button>
                    </div>

                    {showFilter && (
                        <div style={{ boxShadow: '2px 2px 2px' }} className="absolute top-full right-4 transform -translate-y-10 bg-white shadow-xl border rounded-xl w-60 z-50">
                            <ul className="p-2 text-sm">
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <CheckCircle className="w-4 h-4 text-green-500" />
                                    Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <XCircle className="w-4 h-4 text-red-500" />
                                    Non-Working Vehicles
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownAZ className="w-4 h-4 text-gray-600" />
                                    Sort A to Z
                                </li>
                                <li className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2">
                                    <ArrowDownZA className="w-4 h-4 text-gray-600" />
                                    Sort Z to A
                                </li>
                            </ul>

                        </div>
                    )}
                </div>


                {/* List of States */}
                {filteredData.length === 0 ? (
                    <div className="flex items-center justify-center flex-1">
                        <p className="text-gray-500 text-lg">No data found.</p>
                    </div>
                ) : (
                    <div className="flex-1 overflow-y-auto px-4 py-2 ">
                        {filteredData.map((item, index) => (
                            <div
                                style={{ borderBottom: '1px solid gray', borderTop: '1px solid gray', borderLeft: "1px solid gray", padding: '0.5rem', borderRadius: "4rem", borderBottomRightRadius: '0', borderTopRightRadius: '0' }}
                                className="flex items-center justify-between pt-1 pb-1 border-b cursor-pointer relative mb-[0.5rem]"
                                onClick={() => {
                                    setShowPopup(true);
                                    setSelectedItem(item);
                                    setShowHistoryFor((prev) => prev === item.AccidentVehicleCode ? null : item.AccidentVehicleCode);
                                }}


                            >
                                <div style={{ borderBottom: '3px solid #21A6E9', boxShadow: '1px -2px 2px' }} className="rounded-full p-2 w-15 h-15 flex items-center justify-center">
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img3.png' alt="img" className="w-10 h-10 rounded-full" />
                                </div>
                                <div className="flex flex-col items-end ml-auto mr-2">

                                    <p className="text-[14px] font-bold">{item.connectedVendorFullyTime}</p>
                                    <div className="flex items-center gap-2">
                                        {item.currentlyWorkingDriver && (<Circle className="text-green-500 fill-green-500 w-4 h-4 mt-[0.4rem]" />)}
                                        <p className="text-[11px] font-bold mt-1">Accepted on</p>
                                    </div>
                                </div>
                                <div className="relative hidden" onClick={(e) => { e.stopPropagation(); }}>
                                    <MoreVertIcon
                                        className="text-gray-500 cursor-pointer"
                                        onClick={(e) => { setShowOptionsFor((prev) => prev === item.AccidentVehicleCode ? null : item.AccidentVehicleCode) }}
                                    />

                                    {showOptionsFor === item.AccidentVehicleCode && (
                                        <div className="absolute right-0  w-24 bg-white shadow-md border rounded z-10">
                                            <p
                                                className="text-sm px-4 py-2 hover:bg-red-100 text-gray-600 cursor-pointer"
                                                onClick={(e) => {
                                                    // handle delete logic here
                                                    e.stopPropagation();
                                                    setShowOptions(false);
                                                }}
                                            >
                                                Delete
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}


                    </div>)}
            </div>

            {showPopup && <TimelinePopup data={selectedItem} onClose={() => setShowPopup(false)} />}
        </div >

    );
};

export default HistoryDriverPage;
